export abstract class ValidationRule {
  key: string;

  constructor(key: string) {
    this.key = key;
  }

  abstract isValid(value: any): boolean;
}
